import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  selectRoles,
  selectBoundTreeStatus,
} from 'src/v3/settings/settings.slice'
import {
  selectTourCompletions,
  selectTourCompletionsStatus,
  selectActiveTourID,
  selectHasAutoPlayedThisSession,
  autoTourStarted,
} from '../tours.slice'
import { tourRegistry } from '../index'

// Finds the first tour in the registry that the user has access to and hasn't
// completed (or has an updated version), and starts it automatically.
// Intended for use on the self-paced landing page.
export let useAutoTour = () => {
  let dispatch = useAppDispatch()
  let roles = useAppSelector(selectRoles)
  let boundTreeStatus = useAppSelector(selectBoundTreeStatus)
  let completions = useAppSelector(selectTourCompletions)
  let completionsStatus = useAppSelector(selectTourCompletionsStatus)
  let activeTourID = useAppSelector(selectActiveTourID)
  let hasAutoPlayedThisSession = useAppSelector(selectHasAutoPlayedThisSession)

  useEffect(() => {
    if (completionsStatus !== 'fulfilled') return
    if (activeTourID) return
    if (hasAutoPlayedThisSession) return

    let nextTour = tourRegistry.find(
      (tour) =>
        !tour.startingRoute &&
        (boundTreeStatus !== 'limited' || tour.allowInLimited) &&
        (!tour.requiredRoles ||
          roles.some((r) => tour.requiredRoles!.includes(r))) &&
        (!completions[tour.id] ||
          completions[tour.id].completedVersion < tour.version),
    )

    if (nextTour) {
      dispatch(autoTourStarted(nextTour.id))
    }
  }, [
    completionsStatus,
    activeTourID,
    hasAutoPlayedThisSession,
    completions,
    roles,
    boundTreeStatus,
    dispatch,
  ])
}
